import {
  createUseReadContract,
  createUseWriteContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
} from 'wagmi/codegen'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// consolidation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x0000BBdDc7CE488642fb579F8B00f3a590007251)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x0000BBdDc7CE488642fb579F8B00f3a590007251)
 */
export const consolidationAbi = [] as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x0000BBdDc7CE488642fb579F8B00f3a590007251)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x0000BBdDc7CE488642fb579F8B00f3a590007251)
 */
export const consolidationAddress = {
  1: '0x0000BBdDc7CE488642fb579F8B00f3a590007251',
  560048: '0x0000BBdDc7CE488642fb579F8B00f3a590007251',
} as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x0000BBdDc7CE488642fb579F8B00f3a590007251)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x0000BBdDc7CE488642fb579F8B00f3a590007251)
 */
export const consolidationConfig = {
  address: consolidationAddress,
  abi: consolidationAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// directStaking
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const directStakingAbi = [
  { type: 'constructor', inputs: [], stateMutability: 'nonpayable' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'version', internalType: 'uint8', type: 'uint8', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Paused',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'addr',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'RewardPoolContractSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'previousAdminRole',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: true,
      },
      {
        name: 'newAdminRole',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: true,
      },
    ],
    name: 'RoleAdminChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RoleGranted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RoleRevoked',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'addr',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'SignerSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'addr',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Staked',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'addr',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'StakedCompound',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Unpaused',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEPOSIT_SIZE',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_DEPOSIT_SIZE',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PAUSER_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'REGISTRY_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: '___ethDepositContract_deprecated___',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'validatorIds', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'exitToClaimAddress', internalType: 'bool', type: 'bool' },
    ],
    name: 'batchEmergencyExit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'validatorIds', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'batchExit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'validatorId', internalType: 'uint256', type: 'uint256' },
      { name: 'exitToClaimAddress', internalType: 'bool', type: 'bool' },
    ],
    name: 'emergencyExit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ethDepositContract',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'validatorId', internalType: 'uint256', type: 'uint256' }],
    name: 'exit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'uint256', type: 'uint256' },
      { name: 'to', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getExitQueue',
    outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getExitQueueLength',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getNextValidators',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'role', internalType: 'bytes32', type: 'bytes32' }],
    name: 'getRoleAdmin',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'idx', internalType: 'uint256', type: 'uint256' }],
    name: 'getValidatorInfo',
    outputs: [
      { name: 'pubkey', internalType: 'bytes', type: 'bytes' },
      { name: 'claimAddress', internalType: 'address', type: 'address' },
      { name: 'extraData', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'uint256', type: 'uint256' },
      { name: 'to', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getValidatorInfos',
    outputs: [
      { name: 'pubkeys', internalType: 'bytes[]', type: 'bytes[]' },
      { name: 'claimAddresses', internalType: 'address[]', type: 'address[]' },
      { name: 'extraDatas', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'hasRole',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'paused',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'rewardPool',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_rewardPool', internalType: 'address', type: 'address' }],
    name: 'setRewardPool',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_signer', internalType: 'address', type: 'address' }],
    name: 'setSigner',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'claimaddr', internalType: 'address', type: 'address' },
      { name: 'withdrawaddr', internalType: 'address', type: 'address' },
      { name: 'pubkeys', internalType: 'bytes[]', type: 'bytes[]' },
      { name: 'signatures', internalType: 'bytes[]', type: 'bytes[]' },
      { name: 'paramsSig', internalType: 'bytes', type: 'bytes' },
      { name: 'extradata', internalType: 'uint256', type: 'uint256' },
      { name: 'tips', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'stake',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DirectStaking.StakeParams',
        type: 'tuple',
        components: [
          { name: 'extraData', internalType: 'uint256', type: 'uint256' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
          { name: 'claimAddr', internalType: 'address', type: 'address' },
          { name: 'withdrawAddr', internalType: 'address', type: 'address' },
          { name: 'pubkeys', internalType: 'bytes[]', type: 'bytes[]' },
          { name: 'signatures', internalType: 'bytes[]', type: 'bytes[]' },
          { name: 'paramsSig', internalType: 'bytes', type: 'bytes' },
        ],
      },
      { name: 'tips', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'stakeCompound',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'sysSigner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'extraData', internalType: 'uint256', type: 'uint256' },
      { name: 'claimaddr', internalType: 'address', type: 'address' },
      { name: 'withdrawaddr', internalType: 'address', type: 'address' },
      { name: 'pubkeys', internalType: 'bytes[]', type: 'bytes[]' },
      { name: 'signatures', internalType: 'bytes[]', type: 'bytes[]' },
      { name: 'paramsSig', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'verifySigner',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DirectStaking.StakeParams',
        type: 'tuple',
        components: [
          { name: 'extraData', internalType: 'uint256', type: 'uint256' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
          { name: 'claimAddr', internalType: 'address', type: 'address' },
          { name: 'withdrawAddr', internalType: 'address', type: 'address' },
          { name: 'pubkeys', internalType: 'bytes[]', type: 'bytes[]' },
          { name: 'signatures', internalType: 'bytes[]', type: 'bytes[]' },
          { name: 'paramsSig', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'verifySigner',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const directStakingAddress = {
  1: '0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572',
  560048: '0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD',
} as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const directStakingConfig = {
  address: directStakingAddress,
  abi: directStakingAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// executionWithdrawal
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x00000961Ef480Eb55e80D19ad83579A64c007002)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x00000961Ef480Eb55e80D19ad83579A64c007002)
 */
export const executionWithdrawalAbi = [] as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x00000961Ef480Eb55e80D19ad83579A64c007002)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x00000961Ef480Eb55e80D19ad83579A64c007002)
 */
export const executionWithdrawalAddress = {
  1: '0x00000961Ef480Eb55e80D19ad83579A64c007002',
  560048: '0x00000961Ef480Eb55e80D19ad83579A64c007002',
} as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x00000961Ef480Eb55e80D19ad83579A64c007002)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x00000961Ef480Eb55e80D19ad83579A64c007002)
 */
export const executionWithdrawalConfig = {
  address: executionWithdrawalAddress,
  abi: executionWithdrawalAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// rewardPool
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const rewardPoolAbi = [
  { type: 'constructor', inputs: [], stateMutability: 'nonpayable' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'beneficiary',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Claimed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'version', internalType: 'uint8', type: 'uint8', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'milli',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ManagerFeeSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'to', internalType: 'address', type: 'address', indexed: false },
    ],
    name: 'ManagerFeeWithdrawed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Paused',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'claimaddr',
        internalType: 'address[]',
        type: 'address[]',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'int256[]',
        type: 'int256[]',
        indexed: false,
      },
    ],
    name: 'PoolUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'previousAdminRole',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: true,
      },
      {
        name: 'newAdminRole',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: true,
      },
    ],
    name: 'RoleAdminChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RoleGranted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RoleRevoked',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Unpaused',
  },
  {
    type: 'function',
    inputs: [],
    name: 'CONTROLLER_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MANAGER_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ORACLE_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PAUSER_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'beneficiary', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'claimRewards',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'claimRewardsFor',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAccountedBalance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getPendingManagerRevenue',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'claimaddr', internalType: 'address', type: 'address' }],
    name: 'getPendingReward',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'role', internalType: 'bytes32', type: 'bytes32' }],
    name: 'getRoleAdmin',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalShare',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'hasRole',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'managerFeeShare',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'paused',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'milli', internalType: 'uint256', type: 'uint256' }],
    name: 'setManagerFeeShare',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'claimaddrs', internalType: 'address[]', type: 'address[]' },
      { name: 'deltas', internalType: 'int256[]', type: 'int256[]' },
    ],
    name: 'updatePool',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'userInfo',
    outputs: [
      { name: 'accSharePoint', internalType: 'uint256', type: 'uint256' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rewardBalance', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'to', internalType: 'address', type: 'address' },
    ],
    name: 'withdrawManagerRevenue',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const rewardPoolAddress = {
  1: '0xb7019c9184580b2E1f66fCDc3EB6c62621732064',
  560048: '0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0',
} as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const rewardPoolConfig = {
  address: rewardPoolAddress,
  abi: rewardPoolAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStaking = /*#__PURE__*/ createUseReadContract({
  abi: directStakingAbi,
  address: directStakingAddress,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"DEFAULT_ADMIN_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingDefaultAdminRole =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'DEFAULT_ADMIN_ROLE',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"DEPOSIT_SIZE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingDepositSize =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'DEPOSIT_SIZE',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"MAX_DEPOSIT_SIZE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingMaxDepositSize =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'MAX_DEPOSIT_SIZE',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"PAUSER_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingPauserRole =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'PAUSER_ROLE',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"REGISTRY_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingRegistryRole =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'REGISTRY_ROLE',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"___ethDepositContract_deprecated___"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingEthDepositContractDeprecated =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: '___ethDepositContract_deprecated___',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"ethDepositContract"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingEthDepositContract =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'ethDepositContract',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"getExitQueue"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingGetExitQueue =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'getExitQueue',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"getExitQueueLength"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingGetExitQueueLength =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'getExitQueueLength',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"getNextValidators"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingGetNextValidators =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'getNextValidators',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"getRoleAdmin"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingGetRoleAdmin =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'getRoleAdmin',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"getValidatorInfo"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingGetValidatorInfo =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'getValidatorInfo',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"getValidatorInfos"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingGetValidatorInfos =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'getValidatorInfos',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"hasRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingHasRole = /*#__PURE__*/ createUseReadContract({
  abi: directStakingAbi,
  address: directStakingAddress,
  functionName: 'hasRole',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"paused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingPaused = /*#__PURE__*/ createUseReadContract({
  abi: directStakingAbi,
  address: directStakingAddress,
  functionName: 'paused',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"rewardPool"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingRewardPool =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'rewardPool',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"supportsInterface"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"sysSigner"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingSysSigner =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'sysSigner',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"verifySigner"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useReadDirectStakingVerifySigner =
  /*#__PURE__*/ createUseReadContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'verifySigner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStaking = /*#__PURE__*/ createUseWriteContract({
  abi: directStakingAbi,
  address: directStakingAddress,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"batchEmergencyExit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingBatchEmergencyExit =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'batchEmergencyExit',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"batchExit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingBatchExit =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'batchExit',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"emergencyExit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingEmergencyExit =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'emergencyExit',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"exit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingExit = /*#__PURE__*/ createUseWriteContract({
  abi: directStakingAbi,
  address: directStakingAddress,
  functionName: 'exit',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"grantRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingGrantRole =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'grantRole',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingInitialize =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"pause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingPause = /*#__PURE__*/ createUseWriteContract({
  abi: directStakingAbi,
  address: directStakingAddress,
  functionName: 'pause',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"renounceRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingRenounceRole =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'renounceRole',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"revokeRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingRevokeRole =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'revokeRole',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"setRewardPool"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingSetRewardPool =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'setRewardPool',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"setSigner"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingSetSigner =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'setSigner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"stake"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingStake = /*#__PURE__*/ createUseWriteContract({
  abi: directStakingAbi,
  address: directStakingAddress,
  functionName: 'stake',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"stakeCompound"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingStakeCompound =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'stakeCompound',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"unpause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWriteDirectStakingUnpause =
  /*#__PURE__*/ createUseWriteContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'unpause',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStaking = /*#__PURE__*/ createUseSimulateContract(
  { abi: directStakingAbi, address: directStakingAddress },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"batchEmergencyExit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingBatchEmergencyExit =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'batchEmergencyExit',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"batchExit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingBatchExit =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'batchExit',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"emergencyExit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingEmergencyExit =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'emergencyExit',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"exit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingExit =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'exit',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"grantRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingGrantRole =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'grantRole',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingInitialize =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"pause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingPause =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'pause',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"renounceRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingRenounceRole =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'renounceRole',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"revokeRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingRevokeRole =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'revokeRole',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"setRewardPool"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingSetRewardPool =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'setRewardPool',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"setSigner"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingSetSigner =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'setSigner',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"stake"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingStake =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'stake',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"stakeCompound"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingStakeCompound =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'stakeCompound',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link directStakingAbi}__ and `functionName` set to `"unpause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useSimulateDirectStakingUnpause =
  /*#__PURE__*/ createUseSimulateContract({
    abi: directStakingAbi,
    address: directStakingAddress,
    functionName: 'unpause',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"Paused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingPausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'Paused',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"RewardPoolContractSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingRewardPoolContractSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'RewardPoolContractSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"RoleAdminChanged"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingRoleAdminChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'RoleAdminChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"RoleGranted"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingRoleGrantedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'RoleGranted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"RoleRevoked"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingRoleRevokedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'RoleRevoked',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"SignerSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingSignerSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'SignerSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"Staked"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingStakedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'Staked',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"StakedCompound"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingStakedCompoundEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'StakedCompound',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link directStakingAbi}__ and `eventName` set to `"Unpaused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe8239B17034c372CDF8A5F8d3cCb7Cf1795c4572)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0x60Fa52A7Ba9Dc835E2b11ba3A48FfB240EEa52fD)
 */
export const useWatchDirectStakingUnpausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: directStakingAbi,
    address: directStakingAddress,
    eventName: 'Unpaused',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPool = /*#__PURE__*/ createUseReadContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"CONTROLLER_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolControllerRole =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'CONTROLLER_ROLE',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"DEFAULT_ADMIN_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolDefaultAdminRole =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'DEFAULT_ADMIN_ROLE',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"MANAGER_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolManagerRole = /*#__PURE__*/ createUseReadContract(
  {
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'MANAGER_ROLE',
  },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"ORACLE_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolOracleRole = /*#__PURE__*/ createUseReadContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
  functionName: 'ORACLE_ROLE',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"PAUSER_ROLE"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolPauserRole = /*#__PURE__*/ createUseReadContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
  functionName: 'PAUSER_ROLE',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"getAccountedBalance"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolGetAccountedBalance =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'getAccountedBalance',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"getPendingManagerRevenue"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolGetPendingManagerRevenue =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'getPendingManagerRevenue',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"getPendingReward"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolGetPendingReward =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'getPendingReward',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"getRoleAdmin"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolGetRoleAdmin =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'getRoleAdmin',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"getTotalShare"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolGetTotalShare =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'getTotalShare',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"hasRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolHasRole = /*#__PURE__*/ createUseReadContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
  functionName: 'hasRole',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"managerFeeShare"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolManagerFeeShare =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'managerFeeShare',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"paused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolPaused = /*#__PURE__*/ createUseReadContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
  functionName: 'paused',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"supportsInterface"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"userInfo"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useReadRewardPoolUserInfo = /*#__PURE__*/ createUseReadContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
  functionName: 'userInfo',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPool = /*#__PURE__*/ createUseWriteContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"claimRewards"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolClaimRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'claimRewards',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"claimRewardsFor"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolClaimRewardsFor =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'claimRewardsFor',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"grantRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolGrantRole = /*#__PURE__*/ createUseWriteContract(
  { abi: rewardPoolAbi, address: rewardPoolAddress, functionName: 'grantRole' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolInitialize =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"pause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolPause = /*#__PURE__*/ createUseWriteContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
  functionName: 'pause',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"renounceRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolRenounceRole =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'renounceRole',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"revokeRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolRevokeRole =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'revokeRole',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"setManagerFeeShare"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolSetManagerFeeShare =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'setManagerFeeShare',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"unpause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolUnpause = /*#__PURE__*/ createUseWriteContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
  functionName: 'unpause',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"updatePool"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolUpdatePool =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'updatePool',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"withdrawManagerRevenue"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWriteRewardPoolWithdrawManagerRevenue =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'withdrawManagerRevenue',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPool = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardPoolAbi,
  address: rewardPoolAddress,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"claimRewards"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolClaimRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'claimRewards',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"claimRewardsFor"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolClaimRewardsFor =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'claimRewardsFor',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"grantRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolGrantRole =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'grantRole',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolInitialize =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"pause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolPause =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'pause',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"renounceRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolRenounceRole =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'renounceRole',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"revokeRole"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolRevokeRole =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'revokeRole',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"setManagerFeeShare"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolSetManagerFeeShare =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'setManagerFeeShare',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"unpause"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolUnpause =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'unpause',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"updatePool"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolUpdatePool =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'updatePool',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardPoolAbi}__ and `functionName` set to `"withdrawManagerRevenue"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useSimulateRewardPoolWithdrawManagerRevenue =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    functionName: 'withdrawManagerRevenue',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"Claimed"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolClaimedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'Claimed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"ManagerFeeSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolManagerFeeSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'ManagerFeeSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"ManagerFeeWithdrawed"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolManagerFeeWithdrawedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'ManagerFeeWithdrawed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"Paused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolPausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'Paused',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"PoolUpdate"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolPoolUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'PoolUpdate',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"RoleAdminChanged"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolRoleAdminChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'RoleAdminChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"RoleGranted"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolRoleGrantedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'RoleGranted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"RoleRevoked"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolRoleRevokedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'RoleRevoked',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardPoolAbi}__ and `eventName` set to `"Unpaused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xb7019c9184580b2E1f66fCDc3EB6c62621732064)
 * - [__View Contract on Hoodi Etherscan__](https://hoodi.etherscan.io/address/0xb4Fc89a143c764039537aBF965c6fD3d4D5475B0)
 */
export const useWatchRewardPoolUnpausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardPoolAbi,
    address: rewardPoolAddress,
    eventName: 'Unpaused',
  })
